import { TableDefinition } from '@happy-ops-org/manta-client'
import { mkModelFromType } from '@happy-ops-org/manta-model-layer'
import type { CollectionAnnotation, OrcaQueryDefinition } from './types.js'

export const collectionMetaDef = TableDefinition.unsafe<CollectionAnnotation>(
  'mcp_collection_meta',
)
export const CollectionMetaModel = mkModelFromType(collectionMetaDef)

export const orcaQueryDef =
  TableDefinition.unsafe<OrcaQueryDefinition>('mcp_orca_query')
export const OrcaQueryModel = mkModelFromType(orcaQueryDef)
